import './index.less';
import '@bedrock/components/reset.css';
import '@bedrock/components/base.css';
export { default as BedrockButton } from './components/Button';
export { default as BedrockInput } from './components/Input';
export { default as BedrockTabs } from './components/Tabs';
const bizCssPrefix = 'rock';
export { bizCssPrefix };
